import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { ListFieldBaseComponent } from 'app/shared/model/lists/list-field-base-component.model';
import { ListsHandler } from 'app/shared/model/lists/lists-handler.model';

@Component({
  templateUrl: './list-field-number.component.html',
  styleUrls: ['./list-field-number.component.scss'],
  selector: 'cc-list-field-number',
})
export class ListFieldNumberComponent extends ListFieldBaseComponent implements OnInit, AfterViewChecked {
  inputValue = '';

  @ViewChild('itemPropertyField') propertyField: ElementRef<HTMLTextAreaElement>;

  getPropertyValue() {
    return String(this.property.value ?? '');
  }

  ngOnInit(): void {
    this.inputValue = this.property.value as string;
  }

  ngAfterViewChecked() {
    if (this.propertyField) {
      this.propertyField.nativeElement.style.height = `${this.propertyField.nativeElement.scrollHeight}px`;
    }
  }

  isNumberOrEmpty(checkValue: string | undefined) {
    return !checkValue || ListsHandler.isNumber(checkValue);
  }

  onPropertyUpdated(value: string) {
    const isEmptyString = value === '';
    const isNumber = value && ListsHandler.isNumber(value);
    const hasChanged = value !== this.property.value;

    if (isEmptyString || (isNumber && hasChanged)) {
      this.property.value = value;
      this.propertyUpdated.emit({ value });
    }
  }
}
